// extracted by mini-css-extract-plugin
export default {"banner":"Showcase_banner__4Qd77","image":"Showcase_image__tFWqe","backBtn":"Showcase_backBtn__1PRAJ","nextBtn":"Showcase_nextBtn__D+KTv","App":"Showcase_App__DShR+"};